import { PRODUCT_LINKS } from '@/constants/navBar';

const PlatformNavBar = () => {
  return (
    <nav className='w-full'>
      {/* Mobile: Vertical Stack */}
      <div className='md:hidden flex flex-col gap-2 w-full'>
        {PRODUCT_LINKS.map((link) => (
          <a
            href={link.url}
            target='_blank'
            rel='noopener noreferrer external'
            key={link.key}
            className='no-underline w-full'
          >
            <button className='w-full h-[48px] bg-[#fccb15] text-black ld font-semibold px-4 rounded-[4px] hover:bg-[#e6b612] transition-colors duration-200 relative'>
              {link.key}
              {link.isNew && (
                <span className='absolute -top-1 -left-4 bg-[#ff4444] text-white text-[0.7rem] font-semibold px-[12px] py-[1px] rounded-[3px] rotate-[-45deg] z-10 uppercase tracking-[0.5px]'>
                  new
                </span>
              )}
            </button>
          </a>
        ))}
      </div>

      {/* Desktop: Horizontal Layout */}
      <ul className='hidden md:flex items-center leading-none gap-8 p-0 justify-center text-center'>
        {PRODUCT_LINKS.map((link, index) => {
          return (
            <a
              href={link.url}
              target='_blank'
              rel='noopener noreferrer external'
              key={index}
              className='no-underline'
            >
              <li className='relative'>
                <button className='bg-[#fccb15] text-black text-lg font-semibold px-6 py-2 rounded-md hover:bg-[#e6b612] transition-colors duration-200 relative'>
                  {link.key}
                  {link.isNew && (
                    <span className='absolute -top-3 -left-6 bg-[#ff4444] text-white text-[0.7rem] h-[25px] font-semibold px-[16px] rounded-[3px] rotate-[-45deg] z-10 uppercase tracking-[0.5px] items-center justify-center'>
                      new
                    </span>
                  )}
                </button>
              </li>
            </a>
          );
        })}
      </ul>
    </nav>
  );
};

export default PlatformNavBar;
